import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "أين يمكنني التواصل بشأن أي استفسارات متعلقة بسباق جائزة السعودية الكبرى للفورمولا 1 STC 2025؟"
      })
    }), "\n", _jsx(_components.p, {
      children: "يرجى الاتصال على البريد الإلكتروني info@saudimotorsport.com، أو الاتصال على الرقم 9200 21023."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "هل يُسمح لي بالتقاط صور في الحدث؟"
      })
    }), "\n", _jsx(_components.p, {
      children: "نعم، ولكن فقط لأغراض شخصية - لا يُسمح بالتقاط لقطات احترافية دون الحصول على إذن من الفورمولا 1."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "كيف يمكن تغيير تفاصيل التذاكر بعد اكتمال عملية الشراء؟"
      })
    }), "\n", _jsx(_components.p, {
      children: "بمجرد اكتمال عملية شراء التذاكر، لا يمكن تغيير تفاصيل التذاكر."
    }), "\n", _jsx("br", {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
